var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTaskLink)?_c('a',{attrs:{"href":_vm.issue.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.issue.key))]):_vm._e(),_vm._v(" "+_vm._s(_vm._f("removePrefix")((_vm.issue.release_notes || _vm.issue.summary)))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }